module.exports = __webpack_public_path__ + "img/pc-hk.cd10a663.jpg";